/* Martina Verona custom interactions for Broadcast */
(function () {
  'use strict';

  function initMartinaHeader(header) {
    if (!header || header.dataset.mvInitialized === 'true') return;
    header.dataset.mvInitialized = 'true';

    // Broadcast wraps section markup in a short Shopify section box. A sticky
    // child is constrained by that box, so promote the whole header group to
    // the sticky element. This keeps the navigation attached on desktop and
    // mobile while preserving its normal space in the document flow.
    var headerSections = header.closest('.header-sections');
    if (headerSections && header.classList.contains('mv-header--sticky')) {
      headerSections.classList.add('mv-header-sections--sticky');
    }

    var openButton = header.querySelector('[data-mv-menu-open]');
    var panel = header.querySelector('[data-mv-mobile-panel]');
    var closeButtons = panel ? panel.querySelectorAll('[data-mv-menu-close]') : [];
    var closeTimer = null;
    var lastFocused = null;
    var promoRotator = header.querySelector('[data-mv-promo-rotator]');
    var promoTimer = null;
    var cartButtons = header.querySelectorAll('[data-mv-cart-toggle]');
    var cartReservationTimerId = null;
    var autumnCountdownTimerId = null;




    function updateAutumnCountdown() {
      var root = header.querySelector('[data-mv-autumn-countdown]');
      if (!root) return;

      var now = new Date();
      var end = new Date(now);
      end.setHours(23, 59, 59, 999);
      var diff = Math.max(0, end.getTime() - now.getTime());
      var totalSeconds = Math.floor(diff / 1000);
      var hours = Math.floor(totalSeconds / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;

      var h = root.querySelector('[data-mv-countdown-hours]');
      var m = root.querySelector('[data-mv-countdown-minutes]');
      var sec = root.querySelector('[data-mv-countdown-seconds]');
      if (h) h.textContent = String(hours).padStart(2, '0');
      if (m) m.textContent = String(minutes).padStart(2, '0');
      if (sec) sec.textContent = String(seconds).padStart(2, '0');
    }

    function startAutumnCountdown() {
      if (!header.querySelector('[data-mv-autumn-countdown]')) return;
      if (autumnCountdownTimerId) window.clearInterval(autumnCountdownTimerId);
      updateAutumnCountdown();
      autumnCountdownTimerId = window.setInterval(updateAutumnCountdown, 1000);
    }

    function renderCartReservationTime(seconds) {
      var timerEl = document.querySelector('[data-mv-cart-reservation-timer]');
      if (!timerEl) return;
      var mins = Math.floor(seconds / 60);
      var secs = seconds % 60;
      timerEl.textContent = mins + ':' + String(secs).padStart(2, '0');
    }

    function startCartReservationTimer() {
      var timerEl = document.querySelector('[data-mv-cart-reservation-timer]');
      if (!timerEl) return;
      var configured = timerEl ? parseInt(timerEl.getAttribute('data-duration-seconds'), 10) : 600;
      var duration = Number.isFinite(configured) && configured > 0 ? configured : 600;
      var endsAt = Date.now() + (duration * 1000);

      if (cartReservationTimerId) window.clearInterval(cartReservationTimerId);

      function tickCartReservationTimer() {
        // The drawer contents can be re-rendered after add-to-cart/quantity changes,
        // so always resolve the live timer node instead of keeping an old reference.
        var liveTimer = document.querySelector('[data-mv-cart-reservation-timer]');
        if (!liveTimer) return;

        var remaining = Math.max(0, Math.ceil((endsAt - Date.now()) / 1000));
        renderCartReservationTime(remaining);

        if (remaining <= 0 && cartReservationTimerId) {
          window.clearInterval(cartReservationTimerId);
          cartReservationTimerId = null;
        }
      }

      tickCartReservationTimer();
      // A shorter interval keeps the display accurate even if the browser delays timers.
      cartReservationTimerId = window.setInterval(tickCartReservationTimer, 250);
    }

    function syncCartEnhancements() {
      var drawer = document.querySelector('cart-drawer');
      if (!drawer) return;

      var savingsLabel = drawer.getAttribute('data-mv-savings-label') || 'Risparmi';
      drawer.querySelectorAll('[data-mv-savings-copy]').forEach(function (node) {
        node.textContent = savingsLabel;
      });

      var totalNode = drawer.querySelector('[data-cart-total]');
      var checkoutTotal = drawer.querySelector('[data-mv-checkout-total]');
      var discountRow = drawer.querySelector('[data-mv-tier-discount-row]');
      var discountTemplate = drawer.querySelector('template[data-mv-discount-summary]');

      var cents = totalNode ? parseInt(totalNode.getAttribute('data-cart-total'), 10) : parseInt(drawer.getAttribute('data-mv-cart-base-total'), 10);

      if (Number.isFinite(cents)) {
        var tierDiscount = totalNode ? parseInt(totalNode.getAttribute('data-mv-native-discount'), 10) || 0 : 0;
        var finalCents = Math.max(0, cents);

        drawer.setAttribute('data-mv-cart-base-total', String(cents));

        if (discountRow && discountTemplate) {
          discountRow.classList.toggle('is-hidden', tierDiscount <= 0);
          discountRow.replaceChildren(discountTemplate.content.cloneNode(true));
        }

        if (checkoutTotal) {
          checkoutTotal.setAttribute('data-base-total-cents', String(cents));
          checkoutTotal.setAttribute('data-total-cents', String(finalCents));
          checkoutTotal.textContent = finalCents === 0 ? window.theme.strings.free : window.theme.formatMoney(finalCents, window.theme.moneyFormat);
        }
      }
    }

    function updateSearchMetrics() {
      var announcement = header.querySelector('.mv-announcement');
      var headMain = header.querySelector('.mv-head-main');
      var nav = header.querySelector('.mv-nav--stefan');
      var announcementHeight = announcement ? announcement.offsetHeight : 0;
      var mainHeight = headMain ? headMain.offsetHeight : 0;
      var navHeight = (nav && window.getComputedStyle(nav).display !== 'none') ? nav.offsetHeight : 0;
      header.style.setProperty('--mv-announcement-height', announcementHeight + 'px');
      header.style.setProperty('--mv-search-region-height', Math.max(72, mainHeight + navHeight) + 'px');
    }

    function openNativeCart(event) {
      var cartDrawer = document.querySelector('cart-drawer');
      if (!cartDrawer) return;
      event.preventDefault();
      cartDrawer.dispatchEvent(new CustomEvent('theme:cart-drawer:show'));
      if (window.a11y) window.a11y.lastElement = event.currentTarget;
    }

    cartButtons.forEach(function (button) {
      button.addEventListener('click', openNativeCart);
    });

    startAutumnCountdown();

    var nativeCartDrawer = document.querySelector('cart-drawer');
    if (nativeCartDrawer) {
      nativeCartDrawer.addEventListener('theme:cart-drawer:show', function () {
        window.requestAnimationFrame(syncCartEnhancements);
      });
    }

    // Broadcast opens the drawer through more than one path. Clicking the bag fires
    // theme:cart-drawer:show, while adding a product can open it directly through
    // theme:product:added. The theme always emits this document event once the drawer
    // really opens, so use it as the single reliable trigger for the 10-minute timer.
    document.addEventListener('theme:cart-drawer:open', function () {
      startCartReservationTimer();
      window.requestAnimationFrame(syncCartEnhancements);
    });

    document.addEventListener('theme:cart:change', function () {
      window.requestAnimationFrame(syncCartEnhancements);
      // If Shopify re-renders the drawer while it is already open, keep the visible
      // countdown moving instead of leaving the freshly-rendered markup at 10:00.
      window.setTimeout(function () {
        var drawer = document.querySelector('cart-drawer');
        var timer = document.querySelector('[data-mv-cart-reservation-timer]');
        if (drawer && timer && (drawer.classList.contains('is-open') || drawer.cartDrawerIsOpen)) {
          if (!cartReservationTimerId) startCartReservationTimer();
        }
      }, 60);
    });

    syncCartEnhancements();
    updateSearchMetrics();
    window.addEventListener('resize', updateSearchMetrics);

    header.querySelectorAll('.mv-native-search > details').forEach(function (details) {
      details.addEventListener('toggle', function () {
        window.requestAnimationFrame(updateSearchMetrics);
      });
    });

    function initPromoRotator() {
      if (!promoRotator || promoRotator.dataset.mvPromoInitialized === 'true') return;
      var items = Array.prototype.slice.call(promoRotator.querySelectorAll('[data-mv-promo-item]'));
      promoRotator.dataset.mvPromoInitialized = 'true';
      if (!items.length) return;

      var index = Math.max(0, items.findIndex(function (item) { return item.classList.contains('is-active'); }));
      items.forEach(function (item, itemIndex) {
        item.classList.toggle('is-active', itemIndex === index);
      });

      var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (items.length < 2 || reduceMotion) return;

      var interval = parseInt(promoRotator.getAttribute('data-interval'), 10);
      if (!Number.isFinite(interval)) interval = 5000;
      interval = Math.min(10000, Math.max(3000, interval));

      promoTimer = window.setInterval(function () {
        items[index].classList.remove('is-active');
        index = (index + 1) % items.length;
        items[index].classList.add('is-active');
      }, interval);
    }

    // Stable sticky-header state. The previous implementation toggled around
    // a single 48px threshold. Because the header itself changes height while
    // collapsing, browsers (especially Safari/mobile) can hover around that
    // threshold and make the menu jump/flicker. Use hysteresis instead: once
    // compact, keep it compact until the visitor is genuinely back at the top.
    var isHeaderCompact = false;
    var COLLAPSE_AT = 110;
    var EXPAND_AT = 8;

    function setScrolledState(force) {
      if (!header.classList.contains('mv-header--sticky')) return;

      var y = Math.max(0, window.pageYOffset || document.documentElement.scrollTop || 0);
      var nextCompact = isHeaderCompact;

      if (force === true) {
        nextCompact = y > COLLAPSE_AT;
      } else if (!isHeaderCompact && y >= COLLAPSE_AT) {
        nextCompact = true;
      } else if (isHeaderCompact && y <= EXPAND_AT) {
        nextCompact = false;
      }

      if (nextCompact === isHeaderCompact && header.classList.contains('is-scrolled') === nextCompact) return;

      isHeaderCompact = nextCompact;
      header.classList.toggle('is-scrolled', isHeaderCompact);
      if (headerSections) headerSections.classList.toggle('mv-header-sections--compact', isHeaderCompact);
    }

    var scrollTicking = false;
    function onScroll() {
      if (scrollTicking) return;
      scrollTicking = true;
      window.requestAnimationFrame(function () {
        setScrolledState(false);
        scrollTicking = false;
      });
    }

    function openMenu() {
      if (!panel || panel.classList.contains('is-open')) return;
      if (closeTimer) window.clearTimeout(closeTimer);
      lastFocused = document.activeElement;
      panel.setAttribute('aria-hidden', 'false');
      panel.classList.add('is-open');
      if (openButton) openButton.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('mv-menu-lock');
      document.body.classList.add('mv-menu-lock');

      var closeButton = panel.querySelector('.mv-mobile-close');
      if (closeButton) {
        window.setTimeout(function () { closeButton.focus(); }, 180);
      }
    }

    function closeMenu(restoreFocus) {
      if (!panel || !panel.classList.contains('is-open')) return;
      panel.classList.remove('is-open');
      if (openButton) openButton.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('mv-menu-lock');
      document.body.classList.remove('mv-menu-lock');

      closeTimer = window.setTimeout(function () {
        panel.setAttribute('aria-hidden', 'true');
        if (restoreFocus !== false && lastFocused && typeof lastFocused.focus === 'function') {
          lastFocused.focus();
        }
      }, 430);
    }

    if (openButton && panel) {
      openButton.addEventListener('click', openMenu);
      closeButtons.forEach(function (button) {
        button.addEventListener('click', function () { closeMenu(true); });
      });

      panel.querySelectorAll('a').forEach(function (link) {
        link.addEventListener('click', function () { closeMenu(false); });
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && panel.classList.contains('is-open')) {
          closeMenu(true);
        }
      });

      window.addEventListener('resize', function () {
        if (window.innerWidth >= 990 && panel.classList.contains('is-open')) {
          closeMenu(false);
        }
      });
    }

    initPromoRotator();
    setScrolledState(true);
    window.addEventListener('scroll', onScroll, { passive: true });
  }



  function initMartinaProductTabs(section) {
    if (!section || section.dataset.mvTabsInitialized === 'true') return;
    var tabs = Array.prototype.slice.call(section.querySelectorAll('[data-mv-collection-tab]'));
    if (tabs.length < 2) return;

    var panels = Array.prototype.slice.call(section.querySelectorAll('[data-mv-products-panel]'));
    var viewAll = section.querySelector('[data-mv-view-all]');
    section.dataset.mvTabsInitialized = 'true';

    function activateTab(tab, moveFocus) {
      var key = tab.getAttribute('data-mv-collection-tab');
      var activePanel = null;

      tabs.forEach(function (item) {
        var active = item === tab;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-selected', active ? 'true' : 'false');
        item.setAttribute('tabindex', active ? '0' : '-1');
      });

      panels.forEach(function (panel) {
        var active = panel.getAttribute('data-mv-products-panel') === key;
        panel.hidden = !active;
        panel.classList.toggle('is-active', active);
        if (active) activePanel = panel;
      });

      if (activePanel) {
        activePanel.classList.remove('mv-panel-entering');
        // Force a reflow so the subtle Stefan-style transition replays.
        void activePanel.offsetWidth;
        activePanel.classList.add('mv-panel-entering');
        window.setTimeout(function () {
          activePanel.classList.remove('mv-panel-entering');
        }, 430);
      }

      if (viewAll) {
        var url = tab.getAttribute('data-collection-url');
        var collectionTitle = tab.getAttribute('data-collection-title') || '';
        if (url) {
          viewAll.classList.add('is-updating');
          viewAll.setAttribute('href', url);
          if (collectionTitle) {
            viewAll.setAttribute('aria-label', viewAll.textContent.trim() + ' — ' + collectionTitle);
            viewAll.setAttribute('data-active-collection', collectionTitle);
          }
          window.setTimeout(function () { viewAll.classList.remove('is-updating'); }, 170);
        }
      }

      if (moveFocus) tab.focus();
    }

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () { activateTab(tab, false); });
      tab.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight' && event.key !== 'Home' && event.key !== 'End') return;
        event.preventDefault();
        var nextIndex = index;
        if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = tabs.length - 1;
        activateTab(tabs[nextIndex], true);
      });
    });

    activateTab(tabs.find(function (tab) { return tab.classList.contains('is-active'); }) || tabs[0], false);
  }

  function initAllMartinaProductTabs(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-mv-product-tabs]').forEach(initMartinaProductTabs);
  }
  function initAllMartinaHeaders(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-mv-header]').forEach(initMartinaHeader);
  }



  // Colour variant media switching is handled natively by Broadcast.

  initAllMartinaHeaders(document);
  initAllMartinaProductTabs(document);

  document.addEventListener('shopify:section:load', function (event) {
    initAllMartinaHeaders(event.target);
    initAllMartinaProductTabs(event.target);
  });
})();

/* Martina Verona — Italian review count formatting */
(function () {
  function formatMvReviewCounts(root) {
    (root || document).querySelectorAll('[data-mv-review-count]').forEach(function (el) {
      var raw = String(el.getAttribute('data-mv-review-count') || el.textContent || '').replace(/[^0-9]/g, '');
      if (!raw) return;
      var value = Number(raw);
      if (!Number.isFinite(value)) return;
      el.textContent = String(value) + '+';
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ formatMvReviewCounts(document); });
  else formatMvReviewCounts(document);
  document.addEventListener('shopify:section:load', function (event) { formatMvReviewCounts(event.target); });
})();

/* Martina Verona — dynamic offset for sticky product media */
(function () {
  'use strict';

  function initMvProductMediaStickyOffset() {
    var media = document.querySelector('.template-product .mv-product-images-sticky');
    if (!media) return;

    var headerGroup = document.querySelector('.header-sections.mv-header-sections--sticky');
    var root = document.documentElement;

    function updateOffset() {
      if (window.innerWidth < 990) {
        root.style.removeProperty('--mv-product-media-sticky-top');
        return;
      }
      var headerHeight = headerGroup ? Math.max(0, Math.round(headerGroup.getBoundingClientRect().height)) : 0;
      root.style.setProperty('--mv-product-media-sticky-top', (headerHeight + 14) + 'px');
    }

    updateOffset();
    window.addEventListener('resize', updateOffset, { passive: true });

    if (headerGroup && 'ResizeObserver' in window) {
      var observer = new ResizeObserver(function () {
        window.requestAnimationFrame(updateOffset);
      });
      observer.observe(headerGroup);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMvProductMediaStickyOffset);
  } else {
    initMvProductMediaStickyOffset();
  }

  document.addEventListener('shopify:section:load', initMvProductMediaStickyOffset);
})();

/* Martina Verona — clean Kiwi Size Chart proxy beside Taglia */
(function () {
  'use strict';

  function normalizedText(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  }

  function findSizeLegend() {
    var wrappers = Array.prototype.slice.call(document.querySelectorAll('.template-product .product__selectors .selector-wrapper'));
    var sizeWrapper = wrappers.find(function (wrapper) {
      var name = wrapper.querySelector('.radio__legend__option-name, .select__label');
      var text = normalizedText(name && name.textContent);
      return wrapper.classList.contains('selector-wrapper--size') || /^(taglia|taglie|size|taille|grosse|groesse|tamanho)$/.test(text);
    });
    return sizeWrapper ? sizeWrapper.querySelector('.radio__legend') : null;
  }

  function findOriginalKiwiLink() {
    var product = document.querySelector('.template-product .product__content') || document.querySelector('.template-product');
    if (!product) return null;
    return product.querySelector('.ks-chart-modal-link:not(.mv-kiwi-size-proxy), [data-kiwi-size-chart]:not(.mv-kiwi-size-proxy), a[href*="kiwi" i]:not(.mv-kiwi-size-proxy)');
  }

  function findOriginalKiwiContainer(link) {
    if (!link) return null;
    return link.closest('.ks-chart-container') || link.closest('#KiwiSizingChart') || link.parentElement;
  }

  function placeKiwiProxy() {
    if (document.querySelector('.mv-size-chart[data-mv-confirmed-chart]')) return false;
    if (!document.querySelector('.template-product')) return false;

    var legend = findSizeLegend();
    var originalLink = findOriginalKiwiLink();
    if (!legend || !originalLink) return false;

    var originalContainer = findOriginalKiwiContainer(originalLink);
    if (originalContainer) originalContainer.classList.add('mv-kiwi-original-hidden');

    legend.classList.add('mv-kiwi-size-legend');

    var host = legend.querySelector('.mv-kiwi-size-inline');
    if (!host) {
      host = document.createElement('span');
      host.className = 'mv-kiwi-size-inline';
      legend.appendChild(host);
    }

    var proxy = host.querySelector('.mv-kiwi-size-proxy');
    if (!proxy) {
      proxy = document.createElement('button');
      proxy.type = 'button';
      proxy.className = 'mv-kiwi-size-proxy';
      proxy.textContent = 'Guida alle taglie';
      proxy.setAttribute('aria-label', 'Guida alle taglie');
      host.appendChild(proxy);
    }

    if (!proxy.dataset.mvKiwiBound) {
      proxy.dataset.mvKiwiBound = 'true';
      proxy.addEventListener('click', function (event) {
        event.preventDefault();
        var liveLink = findOriginalKiwiLink();
        if (liveLink) liveLink.click();
      });
    }

    return true;
  }

  function initKiwiPlacement() {
    if (!document.querySelector('.template-product')) return;

    placeKiwiProxy();

    var queued = false;
    var observer = new MutationObserver(function () {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(function () {
        queued = false;
        placeKiwiProxy();
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });

    document.addEventListener('change', function (event) {
      if (event.target && event.target.closest && event.target.closest('.product__selectors')) {
        window.setTimeout(placeKiwiProxy, 60);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initKiwiPlacement);
  } else {
    initKiwiPlacement();
  }

  document.addEventListener('shopify:section:load', function () {
    window.setTimeout(placeKiwiProxy, 50);
  });
})();


/* Martina Verona — delivery date = exactly one calendar day from today */
(function () {
  'use strict';
  function addOneDay(date) {
    var result = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    result.setDate(result.getDate() + 1);
    return result;
  }
  function renderDeliveryDates(root) {
    var target = addOneDay(new Date());
    var value = new Intl.DateTimeFormat('it-IT', { day: '2-digit', month: '2-digit' }).format(target);
    (root || document).querySelectorAll('[data-mv-delivery-date]').forEach(function (node) { node.textContent = value; });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ renderDeliveryDates(document); });
  else renderDeliveryDates(document);
  document.addEventListener('shopify:section:load', function(event){ renderDeliveryDates(event.target); });
})();

/* Customer video playback starts with audio after a user gesture. */
(function () {
  'use strict';
  function initializeCustomerVideos(root) {
    (root || document).querySelectorAll('[data-mv-customer-video]').forEach(function (card) {
      if (card.dataset.playerReady) return;
      var video = card.querySelector('video');
      var button = card.querySelector('[data-mv-customer-video-play]');
      if (!video || !button) return;
      card.dataset.playerReady = 'true';
      var pauseButton = document.createElement('button');
      pauseButton.type = 'button';
      pauseButton.className = 'mv-customer-video-pause';
      pauseButton.setAttribute('aria-label', 'Metti in pausa il video');
      pauseButton.hidden = video.paused;
      card.appendChild(pauseButton);
      pauseButton.addEventListener('click', function () { video.pause(); });
      button.hidden = !video.paused;
      video.controls = false;
      video.removeAttribute('controls');
      pauseButton.style.bottom = '0';
      button.addEventListener('click', function () {
        video.muted = false;
        video.defaultMuted = false;
        video.removeAttribute('muted');
        video.volume = 1;
        video.controls = false;
        button.hidden = true;
        var playing = video.play();
        if (playing && playing.catch) playing.catch(function () {
          button.hidden = false;
          video.controls = false;
        });
      });
      video.addEventListener('play', function () {
        button.hidden = true;
        pauseButton.hidden = false;
        video.controls = false;
        document.querySelectorAll('[data-mv-customer-video] video').forEach(function (other) {
          if (other !== video && !other.paused) other.pause();
        });
      });
      video.addEventListener('pause', function () { button.hidden = false; pauseButton.hidden = true; });
      video.addEventListener('ended', function () { button.hidden = false; pauseButton.hidden = true; });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initializeCustomerVideos(document); });
  else initializeCustomerVideos(document);
  document.addEventListener('shopify:section:load', function (event) { initializeCustomerVideos(event.target); });
})();


/* Martina Verona — size guide presentation, draft theme 197830017406 only.
 * Kiwi records are shared store data: this patch never writes to the app.
 * Unverified measurements are not interpolated or borrowed from other items.
 */
(function () {
  'use strict';
  var labels = {'size charts':'Guida alle taglie','size chart':'Guida alle taglie','size':'Taglia','us size':'Taglia US','size us':'Taglia US','size eur':'Taglia EU','chest':'Torace','bust':'Busto','waist':'Vita','hip':'Fianchi','hips':'Fianchi','length':'Lunghezza','sleeve':'Manica','shoulder':'Spalle','foot length':'Lunghezza del piede','flat measure':'Misura in piano','inches':'Pollici','inch':'Pollici','bikini top':'Parte superiore del bikini','bikini bottom':'Parte inferiore del bikini'};
  function norm(v) { return String(v || '').replace(/[\u200b\u00a0]/g,' ').trim().replace(/\s+/g,' ').toLowerCase(); }
  function size(v) { var t=String(v || '').trim().toUpperCase(),m=t.match(/^IT\s*\d+(?:[-–]\d+)?\s*\((XXS|XS|S|M|L|XL|XXL|XXXL|[2-9]XL)\)/);if(m)t=m[1];return t.replace(/^XXXL$/,'3XL').replace(/^XXL$/,'2XL'); }
  function wrapper() { return Array.from(document.querySelectorAll('.template-product .product__selectors .selector-wrapper')).find(function(e){var n=e.querySelector('.radio__legend__option-name,.select__label');return e.classList.contains('selector-wrapper--size') || /^(taglia|taglie|size|taille|tamanho)$/.test(norm(n && n.textContent));}); }
  function sizes() { var w=wrapper(); if(!w)return [];return Array.from(new Set(Array.from(w.querySelectorAll('input[type="radio"],select option')).map(function(e){return size(e.value);}).filter(Boolean))); }
  function note(parent,text,kind) { var p=document.createElement('p');p.className='mv-size-note'+(kind?' '+kind:'');p.textContent=text;parent.appendChild(p);return p; }
  function kindOf(table) { var t=norm(table.textContent);if(/foot length|lunghezza del piede/.test(t))return 'shoe';if(/flat measure|misura in piano/.test(t))return 'swim';if(/97\s*102\s*105/.test(t))return 'cardigan';if(/94\s*98\s*102\s*106/.test(t))return 'blazer';if(/82\s*86\s*90\s*96/.test(t))return 'dress';if(/spalle|shoulder/.test(t))return 'top';return 'pants'; }
  var how = {
    shoe:'<h3>Come misurare il piede</h3><ol><li>Appoggia un foglio sul pavimento, con il tallone contro una parete.</li><li>Rimani in piedi distribuendo il peso su entrambi i piedi e segna la punta del dito più lungo.</li><li>Misura la distanza dalla parete al segno. Ripeti con l’altro piede e considera la misura maggiore.</li><li>Confronta la lunghezza con la tabella. Per dubbi sulla calzata o sullo spazio in punta, chiedici conferma prima dell’acquisto.</li></ol>',
    swim:'<h3>Come prendere le misure</h3><p>Per busto, vita e fianchi, usa un metro morbido senza stringere: misura il punto più ampio del busto, il punto più stretto della vita e il punto più ampio dei fianchi.</p><p>Per confrontare un bikini, stendi entrambi i pezzi su una superficie piana, senza tendere il tessuto. Ripeti ogni misura per verificarla. La voce «Misura in piano» richiede conferma del punto di misurazione: contattaci prima di usarla per scegliere la taglia.</p>',
    dress:'<h3>Come prendere le misure</h3><ul><li><strong>Busto:</strong> misura la circonferenza nel punto più ampio, con il metro orizzontale.</li><li><strong>Vita:</strong> misura il punto più stretto della vita naturale senza stringere.</li><li><strong>Fianchi:</strong> con i piedi uniti, misura il punto più ampio dei fianchi e dei glutei.</li></ul><p>Prima di confrontare la tabella con le tue misure, chiedici conferma se il riferimento riguarda il corpo oppure il capo.</p>',
    jacket:'<h3>Come misurare un capo</h3><p>Stendi una giacca o un cardigan che ti veste bene su una superficie piana, senza tendere il tessuto.</p><ul><li><strong>Torace:</strong> misura da un’ascella all’altra. Questa è una larghezza: non confrontarla direttamente con una circonferenza.</li><li><strong>Spalle:</strong> misura tra le cuciture delle spalle.</li><li><strong>Manica:</strong> misura dalla cucitura della spalla al polsino; se il riferimento parte dal centro del collo, chiedi conferma.</li><li><strong>Lunghezza:</strong> misura sul retro dalla base del collo all’orlo.</li></ul><p>Le misure del corpo e quelle del capo non sono intercambiabili. Se non è chiaro quale riferimento usa la tabella, scrivici per conferma.</p>',
    top:'<h3>Come prendere le misure</h3><ul><li><strong>Busto:</strong> misura attorno al punto più ampio, mantenendo il metro orizzontale.</li><li><strong>Spalle:</strong> misura la distanza tra le due cuciture delle spalle su un capo steso.</li><li><strong>Manica:</strong> misura dalla cucitura della spalla al polsino.</li><li><strong>Lunghezza:</strong> misura dal punto più alto della spalla all’orlo.</li></ul><p>Non confrontare una larghezza misurata in piano con una circonferenza. Per dubbi sul riferimento della tabella o sulla vestibilità del modello, contattaci.</p><p>Le misure manuali possono variare di 2–3 cm. La taglia sull’etichetta può differire dalla taglia ordinata.</p>',
    pants:'<h3>Come misurare pantaloni e gonne</h3><p>Chiudi il capo e stendilo su una superficie piana, eliminando le pieghe senza tendere il tessuto.</p><ul><li><strong>Vita:</strong> misura la cintura da un lato all’altro.</li><li><strong>Fianchi:</strong> misura il punto più ampio del capo.</li><li><strong>Lunghezza:</strong> misura dal bordo superiore della cintura all’orlo lungo il fianco.</li><li><strong>Interno gamba:</strong> misura dalla cucitura del cavallo all’orlo.</li></ul><p>Le larghezze in piano e le circonferenze sono misure diverse. Chiedici conferma del riferimento della tabella prima di confrontarle.</p>'
  };
  function uncertain(cell) { if(!cell || (cell.dataset.mvUnverified && cell.textContent==='—'))return;cell.dataset.mvUnverified='true';cell.textContent='—';cell.classList.add('mv-size-unverified'); }
  // General body reference in cm, not measurements of a Martina garment.
  // Sources: H&M official ladies guide; IT/EU conversion verified with Gucci.
  var euBody={32:[76,60,84],34:[80,64,88],36:[84,68,92],38:[88,72,96],40:[92,76,100],42:[96,80,104],44:[100,84,108],46:[104,88,112],48:[110,94,117],50:[116,100,122],52:[122,106,127],54:[128,112,132],56:[134,118,137],58:[140,124,142],60:[146,130,147],62:[152,136,152]};
  var euLetters={XS:[32,34],S:[36,38],M:[40,42],L:[44,46],XL:[48,50],'2XL':[52,54],'3XL':[56,58],'4XL':[60,62]};
  function rawSizes(){var w=wrapper();return w?Array.from(new Set(Array.from(w.querySelectorAll('input[type="radio"],select option')).map(function(e){return e.value;}).filter(Boolean))):[];}
  function generalEu(table,kind){
    if(table.dataset.mvStandardEu)return true;
    var text=norm(table.textContent),us=Array.from(table.querySelectorAll('th,td')).some(function(c){return /^(us|us size|size us|taglia us)$/.test(norm(c.textContent));});if(!us||/\b(?:eu|eur|european|europea)\b/.test(text))return false;
    table.innerHTML='';table.classList.add('mv-size-native-table');table.dataset.mvStandardEu=kind==='shoe'?'shoe':'body';
    var head=table.createTHead().insertRow();(kind==='shoe'?['EU','Lunghezza piede (cm)']:['Taglia','EU','Busto (cm)','Vita (cm)','Fianchi (cm)']).forEach(function(t){var th=document.createElement('th');th.textContent=t;head.appendChild(th);});var body=table.createTBody();
    if(kind==='shoe'){
      // Official adidas heel-to-toe reference; shoe fit remains model-dependent.
      [['36',22.1],['36⅔',22.5],['37⅓',22.9],['38',23.3],['38⅔',23.8],['39⅓',24.2],['40',24.6],['40⅔',25],['41⅓',25.5],['42',25.9],['42⅔',26.3],['43⅓',26.7],['44',27.1]].forEach(function(row){var tr=body.insertRow();row.forEach(function(v){tr.insertCell().textContent=String(v);});});return true;
    }
    var wanted=rawSizes();if(!wanted.length)wanted=['S','M','L','XL','2XL','3XL'];
    var seen=new Set();wanted.forEach(function(raw){var letter=size(raw);if(seen.has(letter))return;seen.add(letter);var match=String(raw).match(/^IT\s*(\d+)(?:\s*[-–]\s*(\d+))?\s*\(/i);var range=match?[Number(match[1])-4,Number(match[2]||match[1])-4]:euLetters[letter];if(!range)return;var low=euBody[range[0]],high=euBody[range[1]];if(!low||!high)return;var row=[letter,range[0]===range[1]?String(range[0]):range.join('–')];for(var i=0;i<3;i++)row.push(low[i]===high[i]?String(low[i]):low[i]+'–'+high[i]);var tr=body.insertRow();row.forEach(function(v){tr.insertCell().textContent=v;});});
    if(!body.rows.length){['XS','S','M','L','XL','2XL','3XL','4XL'].forEach(function(letter){var range=euLetters[letter],a=euBody[range[0]],b=euBody[range[1]],tr=body.insertRow();[letter,range.join('–'),a[0]+'–'+b[0],a[1]+'–'+b[1],a[2]+'–'+b[2]].forEach(function(v){tr.insertCell().textContent=v;});});}
    return true;
  }
  window.mvNormalizeUsTables=function(root){(root||document).querySelectorAll('.product__description__content table,.product-accordion table,.product-tabs table').forEach(function(table){if(generalEu(table,kindOf(table))&&!table.querySelector('caption')){var caption=table.createCaption();caption.textContent='Guida generale EU — misure di riferimento, non misure del capo.';}});};
  function adaptTable(table,kind) {
    if(generalEu(table,kind))return [];
    var rows=Array.from(table.rows), available=sizes(), missing=[];if(!rows.length)return missing;
    var headings=Array.from(rows[0].cells).map(function(c){return size(c.textContent);});
    if(kind==='cardigan'){rows.slice(1).forEach(function(r){if(/^(chest|torace)$/.test(norm(r.cells[0].textContent))){var i=headings.indexOf('3XL');if(i>=0 && norm(r.cells[i].textContent)==='109')uncertain(r.cells[i]);}});}
    if(kind==='dress'){rows.slice(1).forEach(function(r){if(/^(hip|fianchi)$/.test(norm(r.cells[0].textContent))){var i=headings.indexOf('2XL');if(i>=0 && norm(r.cells[i].textContent)==='140')uncertain(r.cells[i]);}});}
    if(kind==='swim'){rows.slice(1).forEach(function(r){if(size(r.cells[0].textContent)==='XL')uncertain(r.cells[3]);});}
    var horizontal=headings.slice(1).some(function(h){return /^(XS|S|M|L|XL|[2-9]XL)$/.test(h);});
    if(available.length && horizontal){headings.forEach(function(h,i){if(i && !available.includes(h))rows.forEach(function(r){if(r.cells[i])r.cells[i].style.setProperty('display','none','important');});});missing=available.filter(function(s){return !headings.includes(s);});}
    else if(available.length){var col=kind==='shoe'?1:0;var present=[];rows.slice(1).forEach(function(r){if(!r.cells[col])return;var s=size(r.cells[col].textContent);present.push(s);if(!available.includes(s))r.style.setProperty('display','none','important');});missing=available.filter(function(s){return !present.includes(s);});}
    table.querySelectorAll('th').forEach(function(c){var translated=labels[norm(c.textContent)];if(translated && c.textContent!==translated)c.textContent=translated;});
    return missing;
  }
  var processed=new WeakMap();
  function translateModal(modal) {
    modal.setAttribute('lang','it');var close=modal.querySelector('.ks-modal-close');if(close)close.setAttribute('aria-label','Chiudi guida alle taglie');
    modal.querySelectorAll('.modal-title-sub-header').forEach(function(e){if(e.textContent!=='Guida alle taglie')e.textContent='Guida alle taglie';});
    modal.querySelectorAll('.ks-chart-individual').forEach(function(chart){
      var table=chart.querySelector('table');if(!table || processed.get(table)===table.innerHTML)return;
      chart.querySelectorAll('.mv-size-guidance,.mv-size-note').forEach(function(e){e.remove();});
      var kind=table.dataset.mvSizeKind || kindOf(table);table.dataset.mvSizeKind=kind;var missing=adaptTable(table,kind);
      chart.querySelectorAll('.ks-html-content').forEach(function(e){e.hidden=true;e.style.display='none';});
      var box=document.createElement('div');box.className='mv-size-guidance';box.innerHTML=table.dataset.mvStandardEu==='body'?'<h3>Come prendere le misure</h3><p>Misura il busto nel punto più ampio, la vita nel punto più stretto e i fianchi nel punto più ampio, senza stringere il metro.</p>':how[kind==='cardigan'||kind==='blazer'?'jacket':kind];chart.appendChild(box);
      var toggle=chart.querySelector('.ks-unit-toggle,.ks-unit-toggle-container');
      var hasUnit=Array.from(chart.querySelectorAll('span,button,a,div')).some(function(e){return e.children.length===0 && /^(cm|inches|pollici)$/.test(norm(e.textContent));});
      if(!hasUnit)note(box,'Misure in centimetri (cm).');
      note(box,table.dataset.mvStandardEu==='shoe'?'Guida generale EU per la lunghezza del piede. La calzata varia secondo il modello.':table.dataset.mvStandardEu?'Guida generale EU: misure del corpo in centimetri, non misure di questo capo. La vestibilità varia secondo il modello.':'La tabella è un riferimento della categoria. Per confermare le misure e la vestibilità di questo specifico articolo, contattaci.');
      processed.set(table,table.innerHTML);
    });
    modal.querySelectorAll('*').forEach(function(e){if(e.children.length)return;var translated=labels[norm(e.textContent)];if(translated && translated!==e.textContent)e.textContent=translated;});
  }
  function fallback(button) {
    var existing=document.getElementById('mv-size-fallback');if(existing)existing.remove();
    var dialog=document.createElement('dialog');dialog.id='mv-size-fallback';dialog.className='mv-size-fallback';dialog.setAttribute('aria-labelledby','mv-size-fallback-title');
    dialog.innerHTML='<button type="button" class="mv-size-close" aria-label="Chiudi guida alle taglie">×</button><h2 id="mv-size-fallback-title">Guida alle taglie</h2>';
    var title=document.querySelector('.product__title,h1');if(title)note(dialog,title.textContent.trim());
    var data=[['Torace',97,102,105,109,114,null,124,129],['Lunghezza',63,65,67,69,71,73,75,77],['Manica',57,58,59,60,61,62,63,64],['Spalle',45,46,47,48,49,50,51,52]], columns=['S','M','L','XL','2XL','3XL','4XL','5XL'], wanted=sizes();
    var scroll=document.createElement('div');scroll.className='mv-size-scroll';var table=document.createElement('table');table.className='mv-size-native-table';var head=table.createTHead().insertRow();var blank=document.createElement('th');blank.scope='col';blank.textContent='cm';head.appendChild(blank);
    var indexes=columns.map(function(v,i){return wanted.includes(v)?i:-1;}).filter(function(i){return i>=0;});indexes.forEach(function(i){var th=document.createElement('th');th.scope='col';th.textContent=columns[i];head.appendChild(th);});
    var tbody=table.createTBody();data.forEach(function(row){var tr=tbody.insertRow();var th=document.createElement('th');th.scope='row';th.textContent=row[0];tr.appendChild(th);indexes.forEach(function(i){var td=tr.insertCell();td.textContent=row[i+1]===null?'—':String(row[i+1]);if(row[i+1]===null)td.setAttribute('aria-label','Misura da verificare');});});scroll.appendChild(table);dialog.appendChild(scroll);
    note(dialog,'Misure in centimetri (cm). Tabella di riferimento per giacche e capispalla.');
    var guidance=document.createElement('div');guidance.innerHTML=how.jacket;dialog.appendChild(guidance);
    note(dialog,'Taglie disponibili per questo articolo: '+sizes().join(', ')+'.');
    document.body.appendChild(dialog);
    dialog.querySelector('button').addEventListener('click',function(){dialog.close();});
    dialog.addEventListener('close',function(){button.focus();dialog.remove();});
    dialog.addEventListener('click',function(e){if(e.target===dialog){var r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close();}});
    dialog.showModal();
  }
  function init() {
    if(!document.querySelector('.template-product'))return;
    var css=document.createElement('style');css.textContent='.kiwi-sizing-modal[lang="it"].kiwi-sizing-modal .ks-html-content{display:none!important}.mv-size-guidance{font:14px/1.6 sans-serif;padding:16px 4px;color:#292929}.mv-size-guidance h3{font-size:17px;margin:0 0 12px}.mv-size-guidance ul,.mv-size-guidance ol{padding-left:22px}.mv-size-note{font:14px/1.6 sans-serif;margin:12px 0}.mv-size-warning{padding:10px;background:#faf4e9;border-left:3px solid #785b32}.mv-size-unverified{font-size:11px!important}.mv-size-fallback{position:fixed!important;inset:0!important;margin:auto!important;box-sizing:border-box;width:min(560px,calc(100vw - 24px));max-height:85dvh;overflow:auto;border:0;border-radius:6px;padding:28px;color:#292929;background:white;font:14px/1.6 sans-serif}.mv-size-fallback::backdrop{background:rgba(0,0,0,.45)}.mv-size-fallback h2{font-size:22px;margin:0 32px 20px 0}.mv-size-fallback h3{font-size:17px}.mv-size-fallback ul{padding-left:20px}.mv-size-scroll{max-width:100%;overflow-x:auto}.mv-size-native-table{width:100%;border-collapse:collapse;font:12px/1.5 sans-serif}.mv-size-native-table th,.mv-size-native-table td{border:1px solid #e4e4e4;padding:6px 4px;text-align:center;min-width:30px}.mv-size-native-table th[scope=row]{text-align:left;min-width:64px}.mv-size-close{position:absolute;right:10px;top:8px;width:40px;height:40px;border:0;background:white;font-size:28px;cursor:pointer}.mv-size-fallback a,.mv-size-guidance a{color:#5b3039;text-decoration:underline}.kiwi-sizing-modal[lang="it"].kiwi-sizing-modal{position:fixed!important;inset:0!important;width:100vw!important;height:100dvh!important;background:rgba(0,0,0,.45)!important;overflow:hidden!important}.kiwi-sizing-modal[lang="it"].kiwi-sizing-modal .kiwi-sizing-modal-inner{position:absolute!important;left:50%!important;top:50%!important;right:auto!important;bottom:auto!important;transform:translate(-50%,-50%)!important;margin:0!important;width:min(560px,calc(100vw - 24px))!important;max-width:none!important;max-height:85dvh!important;height:auto!important;overflow:auto!important;box-sizing:border-box!important;border:0!important;border-radius:6px!important;padding:28px!important;background:#fff!important;color:#292929!important;font:14px/1.6 sans-serif!important;animation:none!important}.kiwi-sizing-modal[lang="it"].kiwi-sizing-modal .ks-modal-content-wrapper,.kiwi-sizing-modal[lang="it"].kiwi-sizing-modal .ks-modal-content{height:auto!important;max-height:none!important;overflow:visible!important;padding:0!important;margin:0!important}.kiwi-sizing-modal[lang="it"].kiwi-sizing-modal .ks-modal-header{padding:0!important;margin:0 0 24px!important;border:0!important;background:white!important;text-align:left!important}.kiwi-sizing-modal[lang="it"].kiwi-sizing-modal .modal-title{display:flex!important;flex-direction:column!important;gap:20px!important}.kiwi-sizing-modal[lang="it"].kiwi-sizing-modal .modal-title-sub-header{order:1!important;font:bold 22px/1.3 sans-serif!important;text-transform:uppercase!important;margin:0 32px 0 0!important;color:#292929!important}.kiwi-sizing-modal[lang="it"].kiwi-sizing-modal .modal-title-header{order:2!important;font:14px/1.6 sans-serif!important;color:#292929!important;margin:0!important}.kiwi-sizing-modal[lang="it"].kiwi-sizing-modal .ks-modal-close{position:absolute!important;right:10px!important;top:8px!important;width:40px!important;height:40px!important;font:28px/40px sans-serif!important;border:0!important;background:white!important;color:#292929!important;padding:0!important;z-index:2!important}.kiwi-sizing-modal[lang="it"].kiwi-sizing-modal .ks-image,.kiwi-sizing-modal[lang="it"].kiwi-sizing-modal .ks-divider{display:none!important}.kiwi-sizing-modal[lang="it"].kiwi-sizing-modal .ks-table-wrapper{max-width:100%!important;overflow-x:auto!important;padding:0!important}.kiwi-sizing-modal[lang="it"].kiwi-sizing-modal .ks-table{width:100%!important;border-collapse:collapse!important;font:12px/1.5 sans-serif!important;margin:0!important}.kiwi-sizing-modal[lang="it"].kiwi-sizing-modal .ks-table-cell{border:1px solid #e4e4e4!important;padding:6px 4px!important;text-align:center!important;min-width:30px!important;background:white!important;color:#292929!important;font:12px/1.5 sans-serif!important;white-space:normal!important;font-weight:400!important}.kiwi-sizing-modal[lang="it"].kiwi-sizing-modal th[scope="row"]{text-align:left!important;min-width:64px!important}.kiwi-sizing-modal[lang="it"].kiwi-sizing-modal .mv-size-guidance{padding:16px 0 0!important;font:14px/1.6 sans-serif!important}.kiwi-sizing-modal[lang="it"].kiwi-sizing-modal .mv-size-guidance h3{font:bold 17px/1.4 sans-serif!important;text-transform:uppercase!important;margin:0 0 12px!important}.kiwi-sizing-modal[lang="it"].kiwi-sizing-modal .mv-size-guidance p{margin:12px 0!important}.kiwi-sizing-modal[lang="it"].kiwi-sizing-modal .mv-size-guidance li{margin:6px 0!important}';document.head.appendChild(css);
    function refresh(){
      if(document.querySelector('.mv-size-chart[data-mv-confirmed-chart]'))return;
      window.mvNormalizeUsTables(document);
      var w=wrapper();if(!w)return;
      var name=norm(document.querySelector('.product__title,h1')?.textContent);
      var meta=document.getElementById('mv-size-guide-category');var collections=meta?meta.dataset.collections:'';var jacket=/giacca|giacche|giubbotto|cappotto|cappotti|trench|gilet/.test(name) || /(^|,)(giacche[^,]*|capispalla)(,|$)/.test(collections);
      var original=document.querySelector('.template-product .ks-chart-modal-link');
      var b=w.querySelector('.mv-size-fallback-link');
      if(jacket && !original && !b){var legend=w.querySelector('.radio__legend');if(legend){b=document.createElement('button');b.type='button';b.className='mv-kiwi-size-proxy mv-size-fallback-link';b.textContent='Guida alle taglie';legend.classList.add('mv-kiwi-size-legend');legend.appendChild(b);b.addEventListener('click',function(){fallback(b);});}}
      if(original && b)b.remove();
      document.querySelectorAll('.kiwi-sizing-modal').forEach(translateModal);
    }
    var queued=false;new MutationObserver(function(){if(queued)return;queued=true;requestAnimationFrame(function(){queued=false;refresh();});}).observe(document.body,{childList:true,subtree:true});refresh();
    document.addEventListener('shopify:section:load',refresh);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
